import script from "./yes-no-check.vue?vue&type=script&setup=true&lang=ts"
export * from "./yes-no-check.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__